import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasClasificarmovimientosMasivoComponent ($q, $catalogos, FinanzasClasificarMovimientos) {
  var $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.actualizar = actualizar;
  $ctrl.clasificarMovimiento = clasificarMovimiento;
  $ctrl.$onChanges = $onChanges;
  $ctrl.updateMovimiento = updateMovimiento;

  function $onInit () {
    $ctrl.data = null;
    $ctrl.clasificado = false;
  }

  function $onChanges (changes) {
    if (changes.cuentabancaria) {
      $ctrl.data = null;
    }
  }

  function actualizar (data) {
    $ctrl.data = null;
    $ctrl.data = data;
    $ctrl.clasificado = false;
  }

  function clasificarMovimiento () {
    $ctrl.clasificando = true;
    FinanzasClasificarMovimientos.clasificarmovimientomasivo($ctrl.cuentabancaria.ID_Cliente, $ctrl.cuentabancaria.ID_Cuenta, $ctrl.data).then(function (response) {
      $ctrl.clasificado = true;
    });
  }

  function updateMovimiento (movimiento) {
    $ctrl.data.movimiento.Folio = movimiento.Folio;
    $ctrl.data.movimiento.Notas = movimiento.Notas;
    $ctrl.data.movimiento.Importe = movimiento.Importe;
    $ctrl.data.movimiento.ID_Empresa_Cuenta = movimiento.ID_Empresa_Cuenta;
    $ctrl.data.movimiento.ID_Empleado_Cuenta = movimiento.ID_Empleado_Cuenta;
    $ctrl.data.movimiento.Fecha_Movimiento = movimiento.Fecha_Movimiento;
    $ctrl.data.movimiento.Banco_Referencia = movimiento.Banco_Referencia;
  }
}

module.component('finanzasClasificarmovimientosMasivo', {
  controller: FinanzasClasificarmovimientosMasivoComponent,
  template,
  bindings: {
    cuentabancaria: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/clasificarmovimientos/components/masivo/component.js